// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid,  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import LightboxModal from '../../../../../components/LightboxModal';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

// components
import Page from '../../../../../components/Page';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { doc400 } from '../../../../userImage';
import { FDate } from 'src/constants/defaultValues';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function VerifyCode({doc, toast, isMobile, editable, handleUpdateDoc, handleAddDoc, loading}) {

  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  let [type, setType] = useState('');
  let [expiryDate, setExpiryDate] = useState('');
  let [companyName, setCompanyName] = useState('');
  let [licenseNumber, setLicenseNumber] = useState('');
  let [licenseClass, setLicenseClass] = useState('');

  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);

  useEffect(()=>{

    if(doc && doc.id){
        setType(doc.type);
        setExpiryDate(doc.expiry_date);
        setCompanyName(doc.company_name);
        setLicenseNumber(doc.license_number);
        setLicenseClass(doc.license_class);
    }

  },[doc]);

  const handleSubmit = e=>{

      // if(type && expiryDate && companyName && licenseNumber && licenseClass){
        if(!expiryDate){
          toast('warning', 'Please choose a valid expiry date!');
          return;
        }
        if(expiryDate=='Invalid Date'){
          toast('warning', 'Please select a valid expiry date');
          return;
        }
        let newCard = {
          // type,
          expiry_date: new Date(expiryDate).toISOString().split('T')[0],
          // company_name: companyName,
          // license_number: licenseNumber,
          // license_class: licenseClass,
        }

        if(fileId){
          newCard.fileId = fileId;
        }

        if(doc && doc.id){
          handleUpdateDoc(newCard);
        }else{
          if(!newCard.fileId){
            toast('warning',"Please upload the copy of the card!");
            return;
          }
          handleAddDoc(newCard);
        }

        // setExpiryDate('');
        // setType('');
        // setLicenseClass('');
        // setCompanyName('');
        // setLicenseNumber('');
      // }else{
      //   toast('warning', 'Please fill all the fields!')
      // }
  }

  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }

  return (
    <div style={stackStyle}>

      <Stack spacing={2}  direction={{ xs: 'column', md: 'row' }}>
          <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
            }}

          >

        <Grid container spacing={3} sx={{ mb: 1 }}>
          <Grid item xs={3} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/QBCC-logo-${isLight ? 'light' : 'dark'}.png`}
                loading="lazy"
                decoding="async"
            />
          </Grid>
          <Grid item xs={9} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
            </Box>
            <Typography> QBCC Licence</Typography>
            {
                editable?(
                    <Box sx={{ mt:2 }} >
                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <DatePicker format="dd-MM-yyyy" 
                            label="Expiry Date"
                            openTo="day"
                            views={['day','month','year']}
                            value={expiryDate}
                            onChange={(newValue) => {
                            setExpiryDate(newValue);
                            }}
                           
                        />
                    </LocalizationProvider>
                    </Box>
                ):(
                    <Typography>Expires: <span style={{ color: '#fda92d' }}> {FDate(expiryDate)}</span></Typography>
                )
            }
          </Grid>
        </Grid>


          {
            editable?(
              <Box sx={{ mt: 1 }}>
                <DocUploadDropzone
                  label="Upload PDF or Photo"
                  file={file || doc?.file}
                  toast={toast}
                  onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
                />
              </Box>
            ):null
          }
          </Paper>


      </Stack>
      {
            editable?(
              <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ):<DocPreview file={doc.file} />
      }



    </div>
  );
}